import React from "react";
import { ApplicationState } from "../store";
import { YoungDriverState, actions } from "../store/YoungDriver";
import { connect } from "react-redux";
import { FormHelperText, FormControl, makeStyles, Theme } from "@material-ui/core";
import { RadioButtonGroupBase } from "./RadioButtonGroupBase";

type YoungDriverProps = YoungDriverState & {
  onChange: Function;
  forwardedRef?: React.RefObject<HTMLDivElement>;
};

const useStyles = makeStyles((theme: Theme) => ({
  errorMessage: {
    color: theme.palette.error.main,
  },
}));

export const YoungDriverOptions: React.FC<YoungDriverProps> = (props: YoungDriverProps) => {
  const classes = useStyles();
  if (!props.questionVisible) {
    return <React.Fragment />;
  }

  return (
    <FormControl fullWidth ref={props.forwardedRef}>
      <RadioButtonGroupBase
        onChange={props.onChange}
        values={props.values.map(i => ({
          value: i.value,
          title: i.text,
        }))}
        selected={props.selected}
        label={{
          title: props.title,
          id: "youngDriverOption",
        }}
        help={{
          title: props.description?.title,
          description: props.description?.text,
        }}
      />
      {props.showError && <FormHelperText className={classes.errorMessage}>{props.requiredErrorMessage}</FormHelperText>}
    </FormControl>
  );
};

const stateToProps = (state: ApplicationState) => state.youngDriver;
const dispatcherToProps = {
  onChange: actions.youngDriverChanged,
};

export default connect(stateToProps, dispatcherToProps)(YoungDriverOptions);
